import { fieldsInterestedPerson } from "../../../../components/AdministrativeProcedures/commonComponents/interestedPersonIssuingCertificatesInfo/optionsinterestedPersonIssuingCertificates";
import { fieldsInfoAboutExistingCertificate } from "../../../../components/AdministrativeProcedures/commonComponents/informationAboutExistingCertificate/optionsInfoAboutExistingCertificate";
import { isEighteenYearsBetween } from "../../../KnowledgeTest/recordTrainedUsers/cardRecordTrainedUsers/optionsForModalWindowTrainedUser";

export const inputsForHeaderCertificateCardPrint = {
  licenseTypeName: {
    key: "licenseTypeName",
    value: "Удостоверение типа",
    type: "text",
    readOnly: true,
    disabled: true,
  },
  theoreticalExam: {
    key: "theoreticalExam",
    value: "Дата и номер протокола по проверке знаний, теория",
    type: "text",
    readOnly: true,
    disabled: true,
  },
  practicalExam: {
    key: "practicalExam",
    value: "Дата и номер протокола по проверке знаний, практика",
    type: "text",
    readOnly: true,
    disabled: true,
  },
};

export const inputsForFooterCertificateCardPrint = {
  newLicenseNum: {
    key: "newLicenseNum",
    value: "Номер удостоверения",
    type: "text",
    readOnly: false,
    required: false,
    show: false,
    disabled: false,
    maxLength: 6,
    pattern: {
      value: /^[0-9]+[0-9]*$/,
      message: `Введите только цифры`,
    },
  },
  fioRu: {
    key: "fioRu",
    value: "Фамилия, имя, отчество",
    type: "text",
    readOnly: false,
    required: true,
    show: true,
    disabled: false,
  },
  fioEng: {
    key: "fioEng",
    value: "Surname, name",
    type: "text",
    readOnly: false,
    required: true,
    eng: true,
    show: true,
    disabled: false,
    pattern: {
      value: /[^А-Яа-яЁё]/,
      message: "Только латинский алфавит",
    },
  },
  placeOfBornRu: {
    key: "placeOfBornRu",
    value: "Место рождения",
    type: "text",
    readOnly: false,
    required: true,
    show: true,
    disabled: false,
  },
  placeOfBornEng: {
    key: "placeOfBornEng",
    value: "Place of birth",
    type: "text",
    readOnly: false,
    required: true,
    eng: true,
    show: true,
    disabled: false,
    pattern: {
      value: /[^А-Яа-яЁё]/,
      message: "Только латинский алфавит",
    },
  },
  addressOfLivingRu: {
    key: "addressOfLivingRu",
    value: "Адрес места жительства",
    type: "text",
    readOnly: false,
    required: true,
    show: true,
    disabled: false,
  },
  addressOfLivingEn: {
    key: "addressOfLivingEn",
    value: "Address",
    type: "text",
    readOnly: false,
    required: true,
    eng: true,
    show: true,
    disabled: false,
    pattern: {
      value: /[^А-Яа-яЁё]/,
      message: "Только латинский алфавит",
    },
  },
  residence: {
    key: "residence",
    value: "Гражданство",
    type: "text",
    readOnly: false,
    required: true,
    show: true,
    disabled: false,
  },
  residenceEn: {
    key: "residenceEn",
    value: "Residence",
    type: "text",
    readOnly: false,
    required: true,
    eng: true,
    show: true,
    disabled: false,
    pattern: {
      value: /[^А-Яа-яЁё]/,
      message: "Только латинский алфавит",
    },
  },
  dateOfBirth: {
    key: "dateOfBirth",
    value: "Дата рождения",
    type: "date",
    readOnly: false,
    required: true,
    show: true,
    disabled: false,
    customValidation: (value, data) => {
      if (data.dateOfIssueOfCertificate) {
        if (isEighteenYearsBetween(value, data.dateOfIssueOfCertificate)) return null;
        return "Возраст - не менее 18 лет на дату начала обучения";
      }
    },
  },
  dateOfIssueOfCertificate: {
    key: "dateOfIssueOfCertificate",
    value: "Дата выдачи удостоверения",
    type: "date",
    readOnly: false,
    required: true,
    show: true,
    disabled: false,
    customValidation(value) {
      if (new Date(value) > new Date()) {
        return "Дата не может быть позднее текущей";
      } else {
        return null;
      }
    },
  },
  validUntil: {
    key: "validUntil",
    value: "Действительно до",
    type: "date",
    readOnly: true,
    required: false,
    show: true,
    disabled: true,
  },
  specMarks: {
    key: "specMarks",
    value: "Особые отметки",
    type: "text",
    as: "textarea",
    readOnly: false,
    required: false,
    show: true,
    disabled: false,
  },
  medConditionsId: {
    key: "medConditionsId",
    value: "Медицинские показания",
    type: "selectWithSearch",
    readOnly: false,
    required: false,
    show: true,
    disabled: false,
    options: [{ value: null, label: "—", key: "medConditionsId" }],
  },
  inspector: {
    key: "inspector",
    value: "Должностное лицо",
    type: "selectWithSearch",
    readOnly: true,
    required: false,
    show: true,
    disabled: true,
    options: [],
  },
};

export const checkBoxForFooter = {
  vvp: {
    key: "vvp",
    value: "ВВП",
    type: "checkbox",
    readOnly: false,
    required: false,
    disabled: false,
  },
  mp: {
    key: "mp",
    value: "МП",
    type: "checkbox",
    readOnly: false,
    required: false,
    disabled: false,
  },
  m: {
    key: "m",
    value: "М",
    type: "checkbox",
    readOnly: false,
    required: false,
    disabled: false,
  },
  p: {
    key: "p",
    value: "П",
    type: "checkbox",
    readOnly: false,
    required: false,
    disabled: false,
  },
};

export function setOptionsForInputs(mode, props, type) {
  switch (mode) {
    case "view": {
      inputsForFooterCertificateCardPrint.fioEng.show = false;
      inputsForFooterCertificateCardPrint.fioEng.required = false;
      inputsForFooterCertificateCardPrint.placeOfBornEng.show = false;
      inputsForFooterCertificateCardPrint.placeOfBornEng.required = false;
      inputsForFooterCertificateCardPrint.addressOfLivingEn.show = false;
      inputsForFooterCertificateCardPrint.addressOfLivingEn.required = false;
      inputsForFooterCertificateCardPrint.residence.show = false;
      inputsForFooterCertificateCardPrint.residence.required = false;
      inputsForFooterCertificateCardPrint.residenceEn.show = false;
      inputsForFooterCertificateCardPrint.residenceEn.required = false;

      inputsForFooterCertificateCardPrint.fioRu.show = true;
      inputsForFooterCertificateCardPrint.fioRu.required = true;
      inputsForFooterCertificateCardPrint.placeOfBornRu.show = true;
      inputsForFooterCertificateCardPrint.placeOfBornRu.required = true;
      inputsForFooterCertificateCardPrint.addressOfLivingRu.show = true;
      inputsForFooterCertificateCardPrint.addressOfLivingRu.required = true;
      inputsForFooterCertificateCardPrint.dateOfBirth.show = true;
      inputsForFooterCertificateCardPrint.dateOfBirth.required = true;
      inputsForFooterCertificateCardPrint.newLicenseNum.show = false;
      inputsForFooterCertificateCardPrint.newLicenseNum.required = false;
      inputsForFooterCertificateCardPrint.medConditionsId.disabled = false;
      inputsForFooterCertificateCardPrint.medConditionsId.readOnly = false;
      inputsForFooterCertificateCardPrint.specMarks.disabled = false;
      inputsForFooterCertificateCardPrint.specMarks.readOnly = false;
      inputsForFooterCertificateCardPrint.dateOfIssueOfCertificate.disabled = false;
      inputsForFooterCertificateCardPrint.dateOfIssueOfCertificate.required = true;
      inputsForFooterCertificateCardPrint.dateOfIssueOfCertificate.readOnly = false;
      if (type !== 1) {
        inputsForFooterCertificateCardPrint.fioEng.show = true;
        inputsForFooterCertificateCardPrint.fioEng.required = true;
        inputsForFooterCertificateCardPrint.placeOfBornEng.show = true;
        inputsForFooterCertificateCardPrint.placeOfBornEng.required = true;
        inputsForFooterCertificateCardPrint.addressOfLivingEn.show = true;
        inputsForFooterCertificateCardPrint.addressOfLivingEn.required = true;
        inputsForFooterCertificateCardPrint.residence.show = true;
        inputsForFooterCertificateCardPrint.residence.required = true;
        inputsForFooterCertificateCardPrint.residenceEn.show = true;
        inputsForFooterCertificateCardPrint.residenceEn.required = true;
      }
      break;
    }
    case "edit": {
      inputsForFooterCertificateCardPrint.fioRu.show = false;
      inputsForFooterCertificateCardPrint.fioRu.required = false;
      inputsForFooterCertificateCardPrint.fioEng.show = false;
      inputsForFooterCertificateCardPrint.fioEng.required = false;
      inputsForFooterCertificateCardPrint.placeOfBornRu.show = false;
      inputsForFooterCertificateCardPrint.placeOfBornRu.required = false;
      inputsForFooterCertificateCardPrint.placeOfBornEng.show = false;
      inputsForFooterCertificateCardPrint.placeOfBornEng.required = false;
      inputsForFooterCertificateCardPrint.addressOfLivingRu.show = false;
      inputsForFooterCertificateCardPrint.addressOfLivingRu.required = false;
      inputsForFooterCertificateCardPrint.addressOfLivingEn.show = false;
      inputsForFooterCertificateCardPrint.addressOfLivingEn.required = false;
      inputsForFooterCertificateCardPrint.residence.show = false;
      inputsForFooterCertificateCardPrint.residence.required = false;
      inputsForFooterCertificateCardPrint.residenceEn.show = false;
      inputsForFooterCertificateCardPrint.residenceEn.required = false;
      inputsForFooterCertificateCardPrint.dateOfBirth.show = false;
      inputsForFooterCertificateCardPrint.dateOfBirth.required = false;
      inputsForFooterCertificateCardPrint.newLicenseNum.show = true;
      inputsForFooterCertificateCardPrint.newLicenseNum.required = true;
      inputsForFooterCertificateCardPrint.medConditionsId.disabled = true;
      inputsForFooterCertificateCardPrint.medConditionsId.readOnly = true;
      inputsForFooterCertificateCardPrint.specMarks.disabled = true;
      inputsForFooterCertificateCardPrint.specMarks.readOnly = true;
      inputsForFooterCertificateCardPrint.dateOfIssueOfCertificate.disabled = true;
      inputsForFooterCertificateCardPrint.dateOfIssueOfCertificate.required = false;
      inputsForFooterCertificateCardPrint.dateOfIssueOfCertificate.readOnly = true;
      break;
    }
    case "med": {
      const allMedConditions = props.map((item) => {
        return {
          ...item,
          key: "medConditionsId",
        };
      });
      if (inputsForFooterCertificateCardPrint.medConditionsId.options.length === 1) {
        inputsForFooterCertificateCardPrint.medConditionsId.options.push(...allMedConditions);
      }
      break;
    }
    default:
      break;
  }
}
export function getOptionsForInputs() {
  return {
    header: inputsForHeaderCertificateCardPrint,
    footer: inputsForFooterCertificateCardPrint,
    person: fieldsInterestedPerson,
    infoExistingCertification: fieldsInfoAboutExistingCertificate,
  };
}

export const customStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    border: "1px solid #BC865399",
    borderRadius: "6px",
    boxShadow: state.isFocused ? "0 0 0 .25rem #BC865380" : "",
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
    padding: "4px 0",
    marginTop: 6,
    "&:hover": {
      border: "1px solid #BC865399",
    },
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865399",
    "&:hover": {
      color: "#BC865399",
      cursor: "pointer",
    },
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "#BC865399",
  }),
  noOptionsMessage: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    backgroundColor: state.isSelected ? "#BC8653" : "",
    color: state.isSelected ? "#F4F7FA" : "#233E5A",
    "&:hover": {
      color: "#F4F7FA",
      backgroundColor: "#BC865380",
      cursor: "pointer",
    },
  }),
};
export const customErrorStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    border: "1px solid #dc3545",
    borderRadius: "6px",
    boxShadow: state.isFocused ? "0 0 0 .25rem #BC865380" : "",
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
    padding: "4px 0",
    "&:hover": {
      border: "1px solid #BC865399",
    },
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865399",
    "&:hover": {
      color: "#BC865399",
      cursor: "pointer",
    },
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "#BC865399",
  }),
  noOptionsMessage: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    backgroundColor: state.isSelected ? "#BC8653" : "",
    color: state.isSelected ? "#F4F7FA" : "#233E5A",
    "&:hover": {
      color: "#F4F7FA",
      backgroundColor: "#BC865380",
      cursor: "pointer",
    },
  }),
};
